var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6647 0.335182C12.1117 0.782104 12.1117 1.50673 11.6648 1.95367L1.95392 11.6648C1.50698 12.1117 0.782351 12.1117 0.3354 11.6648C-0.111551 11.2179 -0.111566 10.4933 0.335364 10.0463L10.0462 0.335217C10.4932 -0.111725 11.2178 -0.111741 11.6647 0.335182Z",
    fill: "#6165DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.335206 0.335306C0.782146 -0.111627 1.50678 -0.111627 1.95372 0.335306L11.6648 10.0462C12.1117 10.4931 12.1117 11.2178 11.6648 11.6647C11.2179 12.1116 10.4932 12.1116 10.0463 11.6647L0.335206 1.95379C-0.111735 1.50686 -0.111735 0.782239 0.335206 0.335306Z",
    fill: "#6165DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.022e5635a71a1fad7134da85faf8f297.svg";
export { ForwardRef as ReactComponent };